module.exports = __webpack_public_path__ + "img/pay_wechat.c8283e1d.png";